import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { StyledPermissionTable } from "./Permission.style";

const PermissionTable = ({ permissions, access, openPermissionDialog }) => {
  const [module, setModule] = useState("all");
  const [totalCount, setTotalCount] = useState(
    permissions ? permissions.length : 0
  );
  const [page, setPage] = useState(1);
  const numPerPage = 10;

  const startIndex = page === 1 ? 0 : (page - 1) * numPerPage;

  const modules = [...new Set((permissions || []).map((permission) => permission.module))]
    .filter(Boolean)
    .sort();

  useEffect(() => {
    setTotalCount(
      permissions.filter((item) => {
        if (module === "all") {
          return true;
        }
        return item.module === module;
      }).length
    );
    setPage(1);
  }, [module, permissions]);

  return (
    <StyledPermissionTable>
      {(!permissions || permissions.length === 0) && (
        <div className="table-empty">No permissions found.</div>
      )}

      {permissions && permissions.length > 0 && (
        <div className="table-shell">
          <TableContainer component={Paper}>
            <div className="permission-filter">
              <FormControl size="small" sx={{ width: 300 }}>
                <InputLabel id="permission-module-select-label">Module</InputLabel>
                <Select
                  labelId="permission-module-select-label"
                  id="permission-module-select"
                  value={module}
                  label="Module"
                  onChange={(e) => {
                    setModule(e.target.value);
                  }}
                >
                  <MenuItem key="all-key" value="all">
                    All modules
                  </MenuItem>
                  {modules.map((mod) => (
                    <MenuItem key={`permission-module-item-${mod}`} value={mod}>
                      {mod}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <Table sx={{ minWidth: 650 }} aria-label="permission table">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Tag</TableCell>
                  <TableCell>Module</TableCell>
                  <TableCell>URL</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell sx={{ minWidth: 80, textAlign: "right" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {permissions
                  .filter((item) => {
                    if (module === "all") {
                      return true;
                    }
                    return item.module === module;
                  })
                  .sort((a, b) => a.id - b.id)
                  .slice(startIndex, startIndex + numPerPage)
                  .map((row) => (
                    <TableRow
                      key={`permission-item-${row.id}`}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.id}
                      </TableCell>
                      <TableCell>{row.tag}</TableCell>
                      <TableCell>
                        <span className="module-chip">{row.module}</span>
                      </TableCell>
                      <TableCell>{row.endpointUrl}</TableCell>
                      <TableCell>{row.description || "-"}</TableCell>
                      <TableCell sx={{ textAlign: "right" }}>
                        <div className="row-actions">
                          {access.editPermissionAccess && (
                            <Button
                              onClick={() => {
                                openPermissionDialog(row);
                              }}
                              variant="outlined"
                              size="small"
                            >
                              Edit
                            </Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}

                {Math.ceil(totalCount / numPerPage) > 1 && (
                  <TableRow key={"pg"}>
                    <TableCell colSpan={7}>
                      <div className="pagination-section">
                        <Pagination
                          count={Math.ceil(totalCount / numPerPage)}
                          page={page}
                          onChange={(event, value) => {
                            setPage(value);
                          }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </StyledPermissionTable>
  );
};

export default PermissionTable;
